import { useEffect, useState } from 'react'
import {
  CLOUD_ADMIN_SESSION_EVENT,
  getCloudAdminToken
} from '@core/auth/cloudSession'

/**
 * Admin-токен текущей вкладки. Хранится не в Dexie: кассир не должен
 * прочитать admin-JWT из локальной базы.
 */
export function useAuthToken(): string {
  const [token, setToken] = useState(() => getCloudAdminToken())

  useEffect(() => {
    const sync = () => setToken(getCloudAdminToken())
    sync()
    window.addEventListener(CLOUD_ADMIN_SESSION_EVENT, sync)
    return () => window.removeEventListener(CLOUD_ADMIN_SESSION_EVENT, sync)
  }, [])

  return token
}
